import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-model/ids";
import { ReturnStatusZod } from "@redotech/redo-model/return-status";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import {
  InventoryItemDispositionSchema,
  InventoryItemGradeSchema,
  InventoryItemKindSchema,
} from "./create-inventory-item";

const ProcessingReturnItem_ = z.object({
  id: zExt.objectId(),
  productTitle: z.string(),
  variantTitle: z.string(),
  sku: z.string().nullish(),
  quantity: z.number().int().positive(),
  images: z.array(z.string().nullable()),
  reason: z.string().nullish(),
});

const ProcessingReturnData_ = z.object({
  id: zExt.objectId(),
  orderNumber: z.string(),
  status: ReturnStatusZod,
  items: z.array(ProcessingReturnItem_),
  createdAt: z.date(),
  inventoryItemId: inventoryItemIdFormat.schema.nullable(),
  hasCompletedProcessingSession: z.boolean(),
});

const InventoryItemData_ = z.object({
  id: inventoryItemIdFormat.schema,
  kind: InventoryItemKindSchema,
  locationId: locationIdFormat.schema,
  returnId: z.string().nullable(),
  quantity: z.number(),
  grade: InventoryItemGradeSchema.nullable(),
  disposition: InventoryItemDispositionSchema.nullable(),
  createdAt: z.date(),
  hasCompletedProcessingSession: z.boolean(),
});
export const InventoryItemData: z.ZodType<InventoryItemData> =
  InventoryItemData_;
export interface InventoryItemData extends z.infer<typeof InventoryItemData_> {}

const ReturnResult_ = z.object({
  type: z.literal("return"),
  return: ProcessingReturnData_,
});

const InventoryResult_ = z.object({
  type: z.literal("inventory"),
  inventoryItem: InventoryItemData_,
});

const NotFoundResult_ = z.object({ type: z.literal("not_found") });

const LookupResult_ = z.discriminatedUnion("type", [
  ReturnResult_,
  InventoryResult_,
  NotFoundResult_,
]);
export type LookupResult = z.infer<typeof LookupResult_>;

export const lookupForSorting = {
  name: "lookupForSorting" as const,
  input: z.object({ identifier: z.string().min(1) }),
  output: z.object({ result: LookupResult_ }),
};
